import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  emailSelector,
  firstNameSelector,
  lastNameSelector
} from '../../../selectors/profile';
import { languageSelector } from '../../../selectors/translations';
import { usernameSelector } from '../../../selectors/auth';

import { showChatBot } from './quriobot';
import { hideCurrentLiveAgentButton, showLiveAgentChat } from './liveAgentChat';

const ChatComponent = ({ isAuthenticated, chatShow, chatBotShow }) => {
  const language = useSelector(languageSelector) || 'EN';
  const firstName = useSelector(firstNameSelector);
  const lastName = useSelector(lastNameSelector);
  const email = useSelector(emailSelector);
  const caseId = useSelector(usernameSelector);

  useEffect(() => {
    if (chatBotShow) {
      showChatBot(
        isAuthenticated,
        true,
        language,
        firstName,
        lastName,
        email,
        caseId
      );
    } else if (chatShow) {
      showLiveAgentChat(
        true,
        isAuthenticated,
        language,
        email,
        firstName,
        lastName,
        caseId
      );
    } else {
      showChatBot(isAuthenticated, false);
      hideCurrentLiveAgentButton();
    }
  }, [chatBotShow, chatShow, language, firstName, lastName, email, caseId]);

  return null;
};

export default ChatComponent;
